import Parallax from 'parallax-js';
import intlTelInput from 'intl-tel-input';
import axios from 'axios';
import 'intl-tel-input/build/js/utils'
import IMask from 'imask';
import { load } from 'recaptcha-v3'

// Определяем селектор для паралакса
let scene = document.querySelector('.order_block__scene');

// Запускаем паралакс
let parallaxInstance = new Parallax(scene, {
    hoverOnly: true,
    frictionY: 0
});

// Обработчик модальных окон
function openModal(name) {
    let modal_form = document.querySelector(name);
    let close = modal_form.getElementsByClassName("close_modal_window")[0];

    modal_form.classList.add('open');

    close.onclick = function () {
        modal_form.classList.remove('open');
    }

    window.onclick = function (event) {
        if (event.target == modal_form) {
            modal_form.classList.remove('open');
        }
    }
};

// Обработка форм
// Устанавливаем поля требующие валидации
/*
Данные указываются в формате json:
"Название поля": {
        "mask": Если нужна маска для этого поля, например "phone"
        "minlength": минимальная длина поля,
        "valid": false если поле еще не валидно
    },
 */
let validationInput = {
    "name": {
        "mask": false,
        "minlength": 2,
        "valid": false
    },
    "phones": {
        "mask": "phone",
        "minlength": 2,
        "valid": false
    },
    "emails": {
        "mask": "email",
        "minlength": 2,
        "valid": false
    }
};


// Валидация email
function validateEmail(email) {
    let re = /[a-z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&'*+/=?^_`{|}~-]+)*@(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?/;
    return re.test(String(email).toLowerCase());
};

// Валидация phone
function validatePhone(phone) {
    let validate = "_";
    return ((phone.indexOf(validate)) > -1);
};

// Проверка валидности форм
function validate(form, input, inputName, sendButton) {
    let errorMessage = form.querySelector('.email_form__hint--'+ inputName +'');

    // Проверяем валидность полей
    let inputValid = false
    if (inputName === "emails") {
        inputValid = !validateEmail(input['value'])
    } if (inputName === "phones") {
        inputValid = validatePhone(input['value'])
    }

    // Если поля не валидны, то блокируем кнопку, и показываем сообщение об ошибке
    if (inputValid || !(input['value'].length > validationInput[inputName]["minlength"]))
    {
        input.classList.add('error');
        errorMessage.classList.add('error');
        validationInput[inputName]["valid"] = false;
    } else {
        input.classList.remove('error');
        errorMessage.classList.remove('error');
        validationInput[inputName]["valid"] = true;
    }

    // Проверяем заполненность каждого поля
    let validationStatus = [];
    for(let inputName in validationInput) {
        validationStatus.push(validationInput[inputName]["valid"]);
    }
    sendButton.disabled = validationStatus.indexOf(false) > -1;
};

// Парсинг URL
function getParameterByName(name) {
    name = name.replace(/[\[]/, "\\[").replace(/[\]]/, "\\]");
    let regex = new RegExp("[\\?&]" + name + "=([^&#]*)");
    let results = regex.exec(location.search);
    return results === null ? "" : decodeURIComponent(results[1].replace(/\+/g,
        " "));
};

function getUtm(form) {
    // Получаем utm метки и проставляем их в input
    form.querySelector('input[name="property_utm_source"]').value = getParameterByName('utm_source');
    form.querySelector('input[name="property_utm_medium"]').value = getParameterByName('utm_medium');
    form.querySelector('input[name="property_utm_campaign"]').value = getParameterByName('utm_campaign');
};

// Формирование полноценного телефонного номера
function getNumber(form) {
    let code = form.querySelector('.iti__selected-dial-code').innerText;
    let number = form.querySelector('input[name="phones"]');
    number.value = code + " " + number['value'].replace(`${code} `, "");
};

// Отправка данных из формы в обработчик
function send(form) {
    const data = new FormData(form);
    let modals = document.querySelectorAll('.modal');
    axios.post('/.handlers/client.php',data)
        .then(function(response) {
            let modals = document.querySelectorAll('.modal');
            modals.forEach((modal) => {
                modal.classList.remove('open');
                form.classList.remove('sending');
                openModal(".modal_thanks");
                form.reset()
            });
            let cookie_date = new Date ();
            cookie_date.setDate(cookie_date.getDate() + 1);
            document.cookie = "doSomethingOnlyOnce=true; expires="+cookie_date.toGMTString()+"";
        })
        .catch(function (error) {
            let modals = document.querySelectorAll('.modal');
            modals.forEach((modal) => {
                modal.classList.remove('open');
                form.classList.remove('sending');
                openModal(".modal_error");
                form.reset();
            });
        });
};

// Ищем все формы
let forms = document.querySelectorAll('.email_form');
// Запускаем отслеживание каждой найденной формы
forms.forEach((form) => {
    form.reset()
    // Получаем кнопку и сразу же ее отключаем
    let sendButton = form.querySelector('.email_form__button');
    sendButton.disabled = true;
    
    // Перебираем поля требующие валидацию
    for(let inputName in validationInput) {
        // Получаем текущий input в цикле
        let input = form.querySelector("input[name='" + inputName + "']");
        // Для поля с телефоном добавляем выбор страны и автоматически генерируем маску под нее
        if (validationInput[inputName]["mask"] === "phone") {
            intlTelInput(input, {
                autoHideDialCode: false,
                autoPlaceholder: "aggressive",
                separateDialCode: true,
                preferredCountries: ['ru', 'ua', 'by', 'kz', 'uz', 'tj', 'us'],
                customPlaceholder:function(selectedCountryPlaceholder,selectedCountryData){
                    return ''+selectedCountryPlaceholder.replace(/[0-9]/g,'0');
                },
            });
            // Устанавливаем маску
            let phoneMask = IMask(input, {mask: input['placeholder'].replace(/[0-9]/g,'0'), lazy: false});
            // Делаем генерируем маску телефона в зависимости от выбранной страны
            input.addEventListener('focus', function (e) {

                let placeholder = this['placeholder'].replace(/[0-9]/g,'0')
                if (placeholder) {
                    // Обновляем маску на случай, если была выбрана другая страна
                    phoneMask.updateOptions({
                        mask: placeholder
                    });
                }
            });
        }

        // Запуск валидатора
        input.addEventListener('mouseover', function () {
            validate(form, input, inputName, sendButton);
        });
        input.addEventListener('mouseleave', function () {
            validate(form, input, inputName, sendButton);
        });

        // проставляем utm метки
        getUtm(form);

    };

    // Отслеживание клика по кнопке
    sendButton.addEventListener('click', function (e) {
        e.preventDefault();
        load('6LcXxccZAAAAAHEKKMFdzdVXp0LCCbHx_N9Q260F').then((recaptcha) => {
            recaptcha.execute('sendform').then((token) => {
                form.querySelector('input[name="property_check"]').value = token;
                form.classList.add('sending');
                this.disabled = true;
                getNumber(form)
                send(form);
            })
        })
    });
});